// import ChartDisplay from "./components/ChartDisplay";
import MainComponent from "./components/MainComponent";

function App() {
  return (
    <div>
      <MainComponent />
      {/* <ChartDisplay /> */}
    </div>
  );
}

export default App;
